import { render, staticRenderFns } from "./DocumentLock.vue?vue&type=template&id=27c73e2e&"
import script from "./DocumentLock.vue?vue&type=script&lang=ts&"
export * from "./DocumentLock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports